import { Controller } from "@hotwired/stimulus"
import { parseDate, validateDateRange } from "../lib/date_validation"

// Connects to data-controller="reservation-wizard" -- Step 1 of the
// dates-first New Reservation wizard. Client-side date validation only;
// the server is still the source of truth once the form submits.
export default class extends Controller {
  static targets = ["startDate", "endDate", "dateError", "submit"]

  connect() {
    this.validateDates()
  }

  validateDates() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget) return true

    if (this.hasDateErrorTarget) {
      this.dateErrorTarget.classList.add("hidden")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }

    const result = validateDateRange(this.startDateTarget.value, this.endDateTarget.value)

    if (!result.valid) {
      this.showError(result.message)
      return false
    }

    return true
  }

  parseDate(dateString) {
    return parseDate(dateString)
  }

  showError(message) {
    if (this.hasDateErrorTarget) {
      this.dateErrorTarget.textContent = message
      this.dateErrorTarget.classList.remove("hidden")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
    }
  }
}
